import { useState, useCallback, memo } from "react";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

const ImageGalleryConfigForm = memo(function ImageGalleryConfigForm({
  config,
  onUpdate,
  widgetId,
  spaceId,
}) {
  const [showCaptions, setShowCaptions] = useState(
    config.showCaptions || false
  );

  // Add handler to stop propagation
  const stopPropagation = useCallback((e) => {
    if (e) {
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
    }
  }, []);

  const handleCaptionsToggle = useCallback(
    (checked) => {
      setShowCaptions(checked);
      onUpdate({ showCaptions: checked });
    },
    [onUpdate]
  );

  return (
    <div
      className="space-y-4"
      onClick={stopPropagation}
      onMouseDown={stopPropagation}
    >
      <div className="flex items-center space-x-2">
        <Switch
          id="showCaptions"
          checked={showCaptions}
          onCheckedChange={handleCaptionsToggle}
        />
        <Label htmlFor="showCaptions" className="text-white">
          Show Captions
        </Label>
      </div>
    </div>
  );
});

ImageGalleryConfigForm.displayName = "ImageGalleryConfigForm";

export default ImageGalleryConfigForm;
